<ng-container #formDirective=parent-form thr-parent-form>
    <thr-full-data-form-documents [client]="client" [isDisabled]="isDisabled" (view)="onDocumentView($event)"></thr-full-data-form-documents>

    <div class="row justify-content-end" *ngIf="!isDisabled">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                {{ 'general.save'| translate }}
            </button>
        </div>
    </div>
</ng-container>